import type { ReactNode } from 'react';
import { Flex, Heading, ScrollArea, Text } from '@/components/common';
import { PageTopBar } from './PageTopBar';

interface AccountSubpageShellProps {
  onBack: () => void;
  children: ReactNode;
  centerContent?: ReactNode;
  right?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
}

/**
 * Account / settings subpages: PageTopBar + scroll body.
 * Body uses Tailwind `px-5` (Pulp scale) — not Themes `px` — so padding matches
 * discovery / inbox / account hub under Themes `--scaling`.
 */
export function AccountSubpageShell({
  onBack,
  children,
  centerContent,
  right,
  title,
  subtitle,
  ...props
}: AccountSubpageShellProps) {
  return (
    <Flex direction="column" height="100vh" {...props}>
      <PageTopBar backButton onBack={onBack} centerSlot={centerContent} endSlot={right} />
      <ScrollArea>
        <Flex direction="column" px="5" pb="5">
          {(title || subtitle) && (
            <Flex direction="column" mb="4" gap="1">
              {title && (
                <Heading size="5" weight="light">
                  {title}
                </Heading>
              )}
              {subtitle && (
                <Text size="1" color="gray">
                  {subtitle}
                </Text>
              )}
            </Flex>
          )}
          {children}
        </Flex>
      </ScrollArea>
    </Flex>
  );
}

export type { AccountSubpageShellProps };
